import animate from '@play-co/timestep-core/lib/animate';
import View from '@play-co/timestep-core/lib/ui/View';
import ImageView from '@play-co/timestep-core/lib/ui/ImageView';
import { animDuration } from 'src/lib/utils';
import { MultiplyFilter } from '@play-co/timestep-core/ui';

type Offset = {
  x: number;
  y: number;
};

type SpinnerOpts = {
  color?: string;
  offset?: Offset;
  size?: number;
};

export default class SpinnerLocal extends View {
  public image: ImageView;
  private loading: boolean = false;
  private offset: Offset;

  constructor(opts: { superview: View } & SpinnerOpts) {
    super(opts);

    this.updateOpts({
      zIndex: 10001,
      x: 0,
      y: 0,
      width: opts.superview.style.width,
      height: opts.superview.style.height,
      visible: false,
      opacity: 0,
    });

    const size = opts.size || 134;
    this.offset = opts.offset ?? { x: 0, y: 0 };

    this.image = new ImageView({
      superview: this,
      image: 'assets/ui/shared/icons/loading_spinner.png',
      width: size,
      height: size,
      x: this.offset.x + this.style.width * 0.5 - size * 0.5,
      y: this.offset.y + this.style.height * 0.5 - size * 0.5,
      centerAnchor: true,
    });

    if (opts.color) {
      this.image.setFilter(new MultiplyFilter(opts.color));
    }
  }

  public tick(dt: number) {
    const dtS = dt * 0.001;
    this.image.style.r += 2 * dtS;
  }

  public resize(size: number) {
    this.image.updateOpts({
      width: size,
      height: size,
      x: this.style.width * 0.5 - size / 2,
      y: this.style.height * 0.5 - size / 2,
    });
  }

  public isLoading() {
    return this.loading;
  }

  public reset() {
    this.loading = false;
    this.hide();
  }

  public start() {
    this.loading = true;
    this.updateOpts({ opacity: 0, visible: true });
    animate(this).clear().then({ opacity: 1 }, animDuration, animate.easeOut);
  }

  public end() {
    animate(this)
      .clear()
      .then({ opacity: 0 }, animDuration, animate.easeOut)
      .then(() => {
        this.loading = false;
        this.hide();
      });
  }
}
